import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmationService, Message } from 'primeng/api';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';

@Component({
  selector: 'app-bumaster',
  templateUrl: './bumaster.component.html',
  styleUrls: ['./bumaster.component.scss']
})

export class BUMasterComponent implements OnInit {
  date: any;
  submitButton: string = 'Submit'
  BUTable: any = [];
  myDate: any;
  loading: boolean = false;
  msgs: Message[] = [];

  constructor(private _apiService: ApiServiceService, private _utility: AppUtility , private confirmService : ConfirmationService) { }

  ngOnInit(): void {
    this.getAllTableData();
  }

  breadcrumb = [
    {
      title: 'BU List',
      subTitle: 'Dashboard'
    }
  ]

  BUProcessForm = new FormGroup({
    BUName: new FormControl('', [Validators.required]),
    isCustomer : new FormControl(false , [Validators.required])
  })

  BUProcessFormSubmit(BU: FormGroupDirective) {
    console.log(this.BUProcessForm.value);
    if (this.BUProcessForm.valid) {
      this._utility.loader(true);
      let object = this.BUProcessForm.value;
      if (this.submitButton == 'Submit') {
        this._apiService.addBU(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success')
            window.scroll(0, 0)
            this.BUProcessForm.reset();
            // ;          
            Object.keys(this.BUProcessForm.controls).forEach(key => {
              this.BUProcessForm.controls[key].setErrors(null)
            });
            BU.resetForm();
          }
          else {
            this._apiService.showMessage(res.message, 'success');
          }
          this.getAllTableData();
        })
      }
      else {
        object['BUId'] = this.editItemId;
        console.log(object);
        this._apiService.editBU(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success');
            this.BUProcessForm.reset();
            Object.keys(this.BUProcessForm.controls).forEach(key => {
              this.BUProcessForm.controls[key].setErrors(null)
            });
            BU.resetForm();
            this.submitButton = 'Submit'
            this.getAllTableData();
          }

          else {
            this._apiService.showMessage(res.message, 'error');
          }
        })
      }
    }
  }

  editItemId: any;
  EditItem(customer: any) {
    if (customer.id) {
      this.BUProcessForm.controls['BUName'].setValue(customer['value']);
      // Object.keys(this.BUProcessForm.controls).forEach(key => {
      //   this.BUProcessForm.controls[key].setValue(customer[key]);
      // });
      this.submitButton = 'Update'
      this.editItemId = customer.id;
    }
  }

  getAllTableData() {
    this._utility.loader(true);
    this._apiService.dropdowndata('BUMaster')
      .then((res: any) => {
        console.log(res);
        this._utility.loader(false);
        if (res.success == true) {
          this.BUTable = res.returnValue.filter((response:any) => !response.isCustomer)
        }
        else {
          this.BUTable = [];
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.BUTable = [];
      })
  }

  confirm1(costBreakupId: any) {
    this.confirmService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Delete BU Record',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteItem(costBreakupId);
        this.msgs = [{ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' }];
      },
      reject: () => {
        this.msgs = [{ severity: 'info', summary: 'Rejected', detail: 'You have rejected' }];
      }
    });
  }

  deleteItem(id: any) {
    this._utility.loader(true);
    this._apiService.deleteBU(id)
    .then((res: any) => {
      this._utility.loader(false);
      console.log(res);      
      if (res.success == true) {
        this._apiService.showMessage(res.message, 'success');
        this.getAllTableData();
      }

      else {
        window.scroll(0, 0);
        this._apiService.showMessage(res.message, 'error');
        this.getAllTableData();
      }

    })
  }
}